// Add your custom JS here.
(function ($) {




    var lastScrollTop = 0;

    $(window).on("scroll", function () {
        var st = $(this).scrollTop();

        // Add/remove 'down' class based on scroll direction
        if (st > lastScrollTop) {
            $('.site-header').addClass('down');
        } else {
            $('.site-header').removeClass('down');
        }
        lastScrollTop = st;

        // Add/remove 'scrolled' class based on scroll position
        if (st > 56) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });


    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function (e) {

        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });















    // Vertical Swiper Configuration
    const verticalSwiper = new Swiper('.vertical-swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        speed: 600,
        // No navigation or pagination
        navigation: false,
        pagination: false,
    });








    // Select the iframe
    const iframe = document.getElementById('vimeoplayer');

    if (iframe) {
        // Initialize the Vimeo Player
        const player = new Vimeo.Player(iframe);

        // Play button click handler
        $(".playbutton").on("click", function () {
            player.play();
            $(".video-popup").addClass("active");
        });

        // Close button click handler
        $(".video-popup .close").on("click", function () {
            player.pause();
            $(".video-popup").removeClass("active");
        });
    }





    $(".close-popup").on("click", function () {
        $(this).parent().fadeOut(150);
    });




    $(".insurance-popup i").on("click", function () {
        $(this).parent().addClass("hide");
    });




    $(".quote-btn").on("click", function () {
        $(".request-popup").addClass("active");
    });

    $(".request-popup .close").on("click", function () {
        $(".request-popup").removeClass("active");
    });




    $(".backdrop").on("click", function () {
        $(".main-menu, .backdrop, .dropdown-container, .menu-icon").removeClass("active");
    });


    $(".backdrop").on("click", function () {
        $(".primary-navigation, .backdrop, .menu-toggle").removeClass("active");
    });


    $(".site-header__mobile-toggle").on("click", function () {
        $(".site-header").toggleClass("active");
    });


    ////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF
    gsap.registerPlugin(ScrollTrigger);
    // ScrollTrigger.normalizeScroll(true);








    // Select all headings within .fade-title-in
    const headings = document.querySelectorAll('.fade-title-in h1, .fade-title-in h2, .fade-title-in h3, .fade-title-in h4, .fade-title-in h5, .fade-title-in h6');

    headings.forEach((heading) => {
        const originalContent = heading.innerHTML;

        try {
            function wrapWordsRobustly(element) {
                const walker = document.createTreeWalker(
                    element,
                    NodeFilter.SHOW_TEXT,
                    {
                        acceptNode(node) {
                            return node.textContent.trim().length > 0
                                ? NodeFilter.FILTER_ACCEPT
                                : NodeFilter.FILTER_REJECT;
                        }
                    }
                );

                const textNodes = [];
                let node;
                while (node = walker.nextNode()) textNodes.push(node);

                textNodes.forEach(textNode => {
                    const text = textNode.textContent;
                    if (!text.trim()) return;

                    const parts = text.split(/(\s+)/);
                    const fragment = document.createDocumentFragment();

                    parts.forEach((part, index) => {
                        if (part.trim()) {
                            // woord
                            const wordWrapper = document.createElement('span');
                            wordWrapper.className = 'word-wrapper';

                            const wordSpan = document.createElement('span');
                            wordSpan.className = 'word';
                            wordSpan.textContent = part;

                            wordWrapper.appendChild(wordSpan);
                            fragment.appendChild(wordWrapper);
                        } else if (part.length) {
                            // spatie: voeg een normale tekstnode toe i.p.v. &nbsp; in een span
                            fragment.appendChild(document.createTextNode(' '));
                        }
                    });

                    textNode.parentNode.replaceChild(fragment, textNode);
                });
            }

            wrapWordsRobustly(heading);

        } catch (error) {
            console.warn('Word wrapping failed, using fallback method:', error);
            const text = heading.textContent;
            const words = text.split(/\s+/).filter(word => word.trim());
            // Gewone spaties tussen woorden
            heading.innerHTML = words.map(word =>
                `<span class="word-wrapper"><span class="word">${word}</span></span>`
            ).join(' ');
        }

        // Styles (geen .word-space meer)
        if (!document.querySelector('#word-wrapper-styles')) {
            const style = document.createElement('style');
            style.id = 'word-wrapper-styles';
            style.textContent = `
      .word-wrapper {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap; /* maakt elk woord ononderbreekbaar, maar regels breken tussen woorden */
      }
      .word {
        display: inline-block;
        transform: translateY(0);
        white-space: nowrap;
      }
      /* Optioneel: iets extra ruimte tussen woorden, ook mobiel */
      .word-wrapper + .word-wrapper { margin-left: 0.05em; }

      @media (max-width: 768px) {
        .word-wrapper + .word-wrapper { margin-left: 0.05em; }
      }
    `;
            document.head.appendChild(style);
        }

        requestAnimationFrame(() => {
            const words = heading.querySelectorAll('.word');
            if (!words.length) return;

            gsap.fromTo(
                words,
                { y: '100%', opacity: 0 },
                {
                    y: '0%',
                    opacity: 1,
                    stagger: 0.05,
                    duration: 0.6,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: heading,
                        start: 'top 80%',
                        end: 'bottom 20%',
                        toggleActions: 'play none none none',
                        refreshPriority: -1,
                    },
                }
            );
        });
    });


    // Alternative ultra-safe version for mobile
    function mobileFriendlyWordWrapper(headings) {
        headings.forEach((heading) => {
            try {
                // Get plain text and split by spaces
                const originalText = heading.textContent;
                const words = originalText.split(/\s+/).filter(word => word.trim());

                // Create new HTML with explicit spacing
                const wrappedHTML = words.map((word, index) => {
                    const wordHtml = `<span class="word-wrapper"><span class="word">${word}</span></span>`;
                    return index < words.length - 1 ? wordHtml + ' ' : wordHtml;
                }).join('');

                heading.innerHTML = wrappedHTML;

                // Animate
                gsap.fromTo(
                    heading.querySelectorAll('.word'),
                    { y: '100%', opacity: 0 },
                    {
                        y: '0%',
                        opacity: 1,
                        stagger: 0.05,
                        duration: 0.6,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 80%',
                            toggleActions: 'play none none none',
                        },
                    }
                );

            } catch (error) {
                console.warn('Mobile word wrapper failed:', error);
            }
        });
    }

    // Use the mobile-friendly version on touch devices
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        console.log('Touch device detected, using mobile-friendly word wrapper');
        // You can uncomment this line to use the simpler version on mobile devices
        // mobileFriendlyWordWrapper(headings);
    }









    // Select all media items
    const mediaItems = document.querySelectorAll(".parallax>img, .parallax>video, .parallax>iframe, .parallax>svg");

    mediaItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 50 }, // Start slightly down
            {
                y: -50, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });









    // Select all media items
    const mparItems = document.querySelectorAll(".parall");

    mparItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 100 }, // Start slightly down
            {
                y: -100, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });












    // Select all elements with the .fade-in-up class
    const fadeInElements = document.querySelectorAll(".fade-in-up");

    // Check if any .fade-in-up elements exist
    if (fadeInElements.length > 0) {
        fadeInElements.forEach((element) => {
            gsap.from(element, {
                opacity: 0,
                y: 50, // Slide-up effect
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 80%", // Start animation when the element's top reaches 80% of the viewport
                    toggleActions: "play none none reverse", // Play on scroll down, reverse on scroll up
                    once: false, // Set to true if the animation should trigger only once
                }
            });
        });
    }














    // Function to animate countup elements
    if ($('.countup').length) {
        function initCountUp() {
            const countupElements = gsap.utils.toArray('.countup');

            countupElements.forEach(element => {
                // Get the original text content
                const originalText = element.textContent.trim();

                // Parse the text to extract number and any prefix/suffix
                const match = originalText.match(/^([^0-9]*)(\d+)(.*)$/);

                if (!match) return; // Skip if no number found

                const prefix = match[1]; // + or -
                const number = parseInt(match[2]);
                const suffix = match[3]; // % or other characters

                // Set initial value to 0
                element.textContent = prefix + '0' + suffix;

                // Create the animation
                const countUpAnimation = gsap.to(element, {
                    duration: 2,
                    ease: "power1.out",
                    onUpdate: function () {
                        const progress = this.progress();
                        const currentValue = Math.round(number * progress);
                        element.textContent = prefix + currentValue + suffix;
                    },
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%", // Start when element is 80% from top of viewport
                        once: true, // Only animate once
                    }
                });
            });
        }

        // Initialize on page load
        document.addEventListener('DOMContentLoaded', initCountUp);
    }










    /**
     * Video Modal Functionality - Vimeo Only Version
     */
    function initVideoModals() {
        // Get the modal elements
        const videoModal = document.getElementById('video-modal');
        const videoModalClose = document.getElementById('video-modal-close');
        const videoModalIframeContainer = document.getElementById('video-modal-iframe-container');

        if (!videoModal) return; // Exit if modal doesn't exist

        // Get all play buttons
        const videoPlayButtons = document.querySelectorAll('.video-play-button');

        // Add click event to all play buttons
        videoPlayButtons.forEach(button => {
            button.addEventListener('click', function () {
                const videoId = this.getAttribute('data-video-id');
                const videoUrl = this.getAttribute('data-video-url');

                // Create iframe
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', videoUrl);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.setAttribute('allow', 'autoplay; fullscreen');
                iframe.setAttribute('id', 'video-iframe-' + videoId);

                // Clear existing iframe and add new one
                videoModalIframeContainer.innerHTML = '';
                videoModalIframeContainer.appendChild(iframe);

                // Open modal
                videoModal.classList.add('active');

                // Prevent scrolling on body
                document.body.style.overflow = 'hidden';
            });
        });

        // Close modal when clicking the close button
        videoModalClose.addEventListener('click', closeModal);

        // Close modal when clicking outside the content
        videoModal.addEventListener('click', function (event) {
            if (event.target === videoModal) {
                closeModal();
            }
        });

        // Close modal with ESC key
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && videoModal.classList.contains('active')) {
                closeModal();
            }
        });

        function closeModal() {
            // Remove active class
            videoModal.classList.remove('active');

            // Empty iframe container to stop video
            videoModalIframeContainer.innerHTML = '';

            // Restore scrolling
            document.body.style.overflow = '';
        }
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', initVideoModals);





})(jQuery);

